import { Tabs, TabsContent } from '@fortem-monorepo/react-ui'

import { Page } from '@/components/Page'
import { INSTRUMENTS } from '@/constants/links'
import { MarketSummaryTabs } from '@/pages/instruments/market-summary/components/MarketSummaryTabs'
import { MarketSummaryActionsProvider } from '@/pages/instruments/market-summary/market-summary-actions'
import {
  MarketSummaryProvider,
  MarketSummaryTab,
  useMarketSummaryContext,
} from '@/pages/instruments/market-summary/market-summary-context'
import { tabs } from '@/pages/instruments/market-summary/market-summary-tabs'

export interface MarketSummaryPageProps {}

export const MarketSummaryPage: React.FC<MarketSummaryPageProps> = ({}) => {
  return (
    <Page metadata={{ title: 'Market Summary' }} permissions={INSTRUMENTS.MARKET_SUMMARY.permissions}>
      <MarketSummaryProvider>
        <MarketSummaryActionsProvider>
          <PageContent />
        </MarketSummaryActionsProvider>
      </MarketSummaryProvider>
    </Page>
  )
}

interface PageContentProps {}

const PageContent: React.FC<PageContentProps> = ({}) => {
  const { tab, selectTab } = useMarketSummaryContext()

  return (
    <Tabs className={'gap-0 h-full'} value={tab} onValueChange={(val) => selectTab(val as MarketSummaryTab)}>
      <MarketSummaryTabs />
      {tabs.map((tab) => {
        const Comp = tab.component
        return (
          <TabsContent key={tab.value} value={tab.value} className={'flex'}>
            <Comp />
          </TabsContent>
        )
      })}
    </Tabs>
  )
}
